import { Box, Grid, GridItem, Text, Textarea } from "@chakra-ui/react";
import React from "react";
import CustomInput from "../../../components/UI/CustomInput";
import { useSelector } from "react-redux";

export default function DepositAndWithdraw({
  isWithdraw,
  payload,
  setPayload,
  balance,
  myAvailableBalance,
  userName,
  errors = {},
  validateRequiredField,
}) {
  const userData = useSelector((state) => state.account.userData);
  return (
    <Grid className="transaction-modal-grid" templateColumns="repeat(3, 1fr)">
      <GridItem className="transaction-modal-label">
        <Text>{userData?.username}</Text>
      </GridItem>
      <GridItem>
        <CustomInput value={userData?.balance ?? 0} isReadOnly />
      </GridItem>
      <GridItem>
        <CustomInput
          isReadOnly
          value={Math.abs(
            payload?.amount
              ? isWithdraw
                ? userData?.balance + payload?.amount
                : userData?.balance - payload?.amount
              : 0
          )}
        />
      </GridItem>
      <GridItem className="transaction-modal-label">
        <Text>{payload?.user?.username}</Text>
      </GridItem>
      <GridItem>
        <CustomInput value={payload?.user?.balance ?? 0} isReadOnly />
      </GridItem>
      <GridItem>
        {!userName && (
          <CustomInput
            isReadOnly
            max={myAvailableBalance}
            value={Math.abs(
              payload?.amount
                ? isWithdraw
                  ? payload?.user?.balance - payload?.amount
                  : payload?.user?.balance + payload?.amount
                : 0
            )}
          />
        )}
      </GridItem>
      <GridItem className="transaction-modal-label">
        <Text>Amount</Text>
      </GridItem>
      <GridItem colSpan={2}>
        <CustomInput
          required
          className="transaction-amount-input"
          error={errors.amount}
          onFocus={() => validateRequiredField("amount", "The Amount field is required")}
          onChange={(e) => {
            setPayload({
              ...payload,
              amount: e.target.value === "" ? "" : Number(e.target.value),
            });
          }}
          type="number"
        />
      </GridItem>
      <GridItem className="transaction-modal-label transaction-modal-label--top">
        <Text>Remark</Text>
      </GridItem>
      <GridItem colSpan={2}>
        <Box className={`transaction-remark-control${errors.remarks ? " has-error" : ""}`}>
          <Textarea
            required
            className="transaction-modal-remark"
            onFocus={() => validateRequiredField("remarks", "The Remark field is required")}
            onChange={(e) => {
              setPayload({ ...payload, remarks: e.target.value });
            }}
          />
          {errors.remarks && <Text className="modal-field-error">{errors.remarks}</Text>}
        </Box>
      </GridItem>
      <GridItem className="transaction-modal-label">
        <Text>Transaction Password sa</Text>
      </GridItem>
      <GridItem colSpan={2}>
        <CustomInput
          required
          minLength={6}
          error={errors.transactionPassword}
          onFocus={() => validateRequiredField("transactionPassword", "The Transaction Code field is required")}
          type="password"
          name="client-balance-transaction-code"
          autoComplete="new-password"
          value={payload?.transactionPassword}
          onChange={(e) =>
            setPayload({ ...payload, transactionPassword: e.target.value })
          }
        />
      </GridItem>
    </Grid>
  );
}
